import * as DialogPrimitive from "@radix-ui/react-dialog";
import { Button } from "@sylviq/ui-react-web/components/ui/button";
import { X } from "lucide-react";
import type { ReactNode } from "react";

interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  description?: string;
  children: ReactNode;
}

export function Dialog({ open, onOpenChange, title, description, children }: DialogProps) {
  return (
    <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
      <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="fixed inset-0 z-50 bg-[var(--overlay)] backdrop-blur-sm data-[state=open]:animate-in" />
        <DialogPrimitive.Content className="surface fixed left-1/2 top-1/2 z-50 w-[min(34rem,calc(100%-2rem))] -translate-x-1/2 -translate-y-1/2 rounded-2xl p-6 shadow-2xl focus:outline-none">
          <div className="pr-12">
            <DialogPrimitive.Title className="text-lg font-semibold">{title}</DialogPrimitive.Title>
            {description ? (
              <DialogPrimitive.Description className="mt-1 text-sm text-[var(--muted-foreground)]">
                {description}
              </DialogPrimitive.Description>
            ) : null}
          </div>
          <div className="mt-5">{children}</div>
          <DialogPrimitive.Close asChild>
            <Button className="absolute right-4 top-4" variant="ghost" size="icon" aria-label="Close dialog">
              <X className="size-4" />
            </Button>
          </DialogPrimitive.Close>
        </DialogPrimitive.Content>
      </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
}
